// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__KBMZf","desabilitar":"OptionSelect_desabilitar__+3lFV","focado":"OptionSelect_focado__3uwFd","novo":"OptionSelect_novo__PWlot"};